import { BCMSRecord, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from '@bcm-dev/bcms-vite';
import { CardOnFileMerchant, Transaction } from "model";
import React from "react";

import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import TabsContainer, { TabItem } from "components/shared/containers/TabsContainer";
import CardOnFileView from "../CardOnFilePage/components/CardOnFileView";
import RecurringPaymentsView from "../CardOnFilePage/components/RecurringPaymentsView";
import "./styles.css";

/**
 * @function CardOnFilePageV2
 * @return {React.Component}
 * @exported true
 * @description The main component for CardOnFilePageV2
 */
export default function CardOnFilePageV2(props) {
    const globalController = useBCMSContext();
    const workflow = useWorkflow() ?? {};
    BCMSRecord.globalControllerFor([ CardOnFileMerchant ], globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  
    const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
    });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
        <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = () => {
  const cardOnFileMerchants = CardOnFileMerchant.initAll();
  
    return {
      cardOnFileMerchants
    };
  }
  
  export const getDefaultUI = () => ({
  
  });

function PageContent(props) {
    const { data, ui } = useStateManager();
    const cardOnFileViewData = data.cardOnFileViewData ? { data: data.cardOnFileViewData } : {};
    const recurringPaymentsViewData = data.recurringPaymentsViewData ? { data: data.recurringPaymentsViewData } : {};
    const _data = data ? { data: data } : {};
    const _ui = ui ? { ui: ui } : {};

    const cardID = useParams().cardID ?? "0";
    const controller = useBCMSContext();
    const navigate = useRoute();
  
    BCMSRecord.globalControllerFor([ Transaction ], controller);
    const recurringRoutes = [ "/home/cardonfileworkflow/recurringpayments", "/home/cardonfileworkflow" ];
    const onFileRoutes = [ "/home/cardonfileworkflow/cardonfile" ];
  
    const recurringLink = `/home/cardonfileworkflow/recurringpayments/${ cardID }`;
    const onFileLink = `/home/cardonfileworkflow/cardonfile/${ cardID }`;
    const location = window.location.href;

    return (
    <MainContentContainer 
      className="card-on-file-page" 
      header={ 
        <MainContentHeader text="Card on File" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } /> 
      }>
      
      <TabsContainer className="bottom-border">
        <TabItem text="Recurring Payments" route={ recurringLink } activeRoute={ recurringRoutes } activeClass="active-tab active" icon="RefreshIcon" dataPoint="Card_On_File_Recurring"></TabItem>
        <TabItem text="Card on File" route={ onFileLink } activeRoute={ onFileRoutes } activeClass="active-tab" icon="ShoppingCartIcon" dataPoint="Card_On_File_Card"></TabItem>
      </TabsContainer>
      <div className="tab-content-container">
        { !location.includes("recurringpayments") && 
        <CardOnFileView { ..._data } { ..._ui } />
        }
        { location.includes("recurringpayments") && 
        <RecurringPaymentsView { ..._data } { ..._ui } />
        }
      </div>
    </MainContentContainer>
    );
}